import { IOffersForShowMultiOffers } from '../types';
import { IOfferCardProps } from '../../../components/OfferCard';

export const getObjectForAnalyticsAboutMultiOffers = (offers: IOfferCardProps[]) => {
  const result = {} as IOffersForShowMultiOffers;

  offers.forEach((offer, index) => {
    result[index] = {
      creditAmount: offer.conditions.limit,
      monthlyPayment: offer.conditions.monthlyPayment,
      interestRate: offer.conditions.rate?.rate,
    };
  });

  return result;
};
